<template>
  <el-card shadow="never"
           class="aui-card--fill">
    <div class="all">
      <div class="top">
        <el-tabs v-model="activeName">
          <el-tab-pane label="用户详情"
                       name="first">
            <UserDetails ref="UserDetails"></UserDetails>
          </el-tab-pane>
          <el-tab-pane label="编辑资料"
                       name="second">
            <EditMaterials ref="EditMaterials"></EditMaterials>
          </el-tab-pane>
          <el-tab-pane label="登录日志"
                       name="third">
            <LoginJournal ref="LoginJournal"></LoginJournal>
          </el-tab-pane>
        </el-tabs>
      </div>
    </div>
  </el-card>
</template>

<script>
import UserDetails from './user-details'
import EditMaterials from './edit-materials'
import LoginJournal from './login-journal'

export default {
  data () {
    return {
      dataForm: {
        creatorName: '',
        custId: ''
      },
      activeName: 'first'
    }
  },
  methods: {
    getDateForm () {
      this.$refs.UserDetails.init(this.activeName)
      this.$refs.EditMaterials.init(this.activeName)
      this.$refs.LoginJournal.init(this.activeName)
    }
  },
  components: {
    UserDetails,
    EditMaterials,
    LoginJournal
  },
  activated () {
    if (this.$route.params.val === 'edit') {
      this.dataForm.custId = this.$route.params.custId
      this.getDateForm()
    }
  }
}
</script>
